import { lazy, Suspense } from "react";
import { useCurrentModal } from "@/stores/modal-store";
import SignInModal from "@/pages/auth/SignInPage";
import ForgotPasswordModal from "@/pages/auth/ForgotPasswordModal";

export default function ModalManager() {
  const currentModal = useCurrentModal();

  if (!currentModal) return null;

  return (
    <Suspense fallback={null}>
      {currentModal === "signin" && <SignInModal />}
      {currentModal === "forgot" && <ForgotPasswordModal />}
    </Suspense>
  );
}
